<template>
    <div class="simple-list">
        <div class="list-item" @click="selectItem(index)" :key="index" v-for="(item, index) in listData">{{item.name}}</div>
        <div class="list-item" @click="selectCarrierEmailSettings()">Farmnoteからメールがとどかない場合の対処法</div>
    </div>
</template>

<script>
import { listData } from '../listData'
export default {
    name: 'top-page',
    data () {
        return {
            listData
        }
    },
    methods: {
        selectItem (index) {
            this.$router.push({
                name: 'detail',
                params: { index: index }
            })
        },
        selectCarrierEmailSettings () {
            this.$router.push({
                name: 'carrier-email-settings'
            })
        }
    }
}
</script>

<style scoped>
.list-item {
    height: 70px;
    line-height: 1.3em;
    display: flex;
    align-items: center;
    padding: 0 20px;
    font-weight: 600;
    font-size: 16px;
    border-bottom: 1px solid #f2f2f2;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/TopPage.vue